var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import DepositStatusComponent from './DepositConfirmationComponent';
import PropTypes from 'prop-types';
import Modal from '../common/Modal/Modal';
import { getQueryParam } from '../../helpers/queryParamsHelper';
var DepositStatusModalComponent = function (_React$Component) {
  _inherits(DepositStatusModalComponent, _React$Component);
  function DepositStatusModalComponent() {
    _classCallCheck(this, DepositStatusModalComponent);
    var _this = _possibleConstructorReturn(this, (DepositStatusModalComponent.__proto__ || Object.getPrototypeOf(DepositStatusModalComponent)).call(this));
    _this.state = {
      txnState: '',
      title: ''
    };
    return _this;
  }
  _createClass(DepositStatusModalComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var txnState = getQueryParam('txnState');
      var trustPayRedirect = getQueryParam('id') && getQueryParam('resourcePath') && getQueryParam('resourcePath').includes('payment');
      var title = void 0;
      if (trustPayRedirect || txnState === '1') {
        title = 'Deposit pending';
        this.setState(function () {
          return {
            txnState: 1,
            title: title
          };
        });
        this.props.openModal();
      }
      if (txnState === '2') {
        title = 'Deposit succesfull';
        this.setState(function () {
          return {
            txnState: txnState,
            title: title
          };
        });
        this.props.openModal();
      }
      if (txnState === '3') {
        title = 'Deposit error';
        this.setState(function () {
          return {
            txnState: txnState,
            title: title
          };
        });
        this.props.openModal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        _close = _props.close,
        isOpen = _props.isOpen;
      var _state = this.state,
        txnState = _state.txnState,
        title = _state.title;
      if (txnState) {
        return React.createElement(Modal, {
          isOpen: isOpen,
          title: this.context.t(title),
          close: function close() {
            return _close();
          }
        }, React.createElement(DepositStatusComponent, {
          txnState: txnState
        }));
      } else {
        return null;
      }
    }
  }]);
  return DepositStatusModalComponent;
}(React.Component);
DepositStatusModalComponent.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};
DepositStatusModalComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default DepositStatusModalComponent;